import { computed } from "vue";
import { escapeRegex } from "Util/util";

export function useFilterableList(items, searchTerm, filter, searchTermParser) {
    const filteredList = computed(() => {
        return items.value.filter((x) => filter(x, parsedSearchTerm.value));
    });

    const parsedSearchTerm = computed(() => {
        return internalSearchTermParser(searchTerm.value);
    });

    const internalSearchTermParser =
        searchTermParser ||
        function (searchTerm) {
            return new RegExp(escapeRegex(searchTerm), "i");
        };

    return {
        filteredList,
        parsedSearchTerm
    };
}
